var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsAccountHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none",
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4D4D4D",
    fillRule: "evenodd",
    d: "M13.825 3.15C7.93 3.15 3.15 7.93 3.15 13.825c0 5.896 4.78 10.675 10.675 10.675 5.896 0 10.675-4.78 10.675-10.675 0-5.896-4.78-10.675-10.675-10.675zM1.167 13.825c0-6.991 5.667-12.658 12.658-12.658s12.658 5.667 12.658 12.658-5.667 12.658-12.658 12.658c-6.99 0-12.658-5.667-12.658-12.658zm12.989-5.389c-.584-.1-1.184.01-1.695.31-.51.3-.899.771-1.095 1.33-.182.517-.748.788-1.265.606-.517-.181-.788-.748-.606-1.264.352-1 1.046-1.845 1.96-2.382.915-.538 1.99-.734 3.036-.555 1.046.18 1.994.723 2.677 1.535.683.811 1.057 1.838 1.055 2.898 0 1.693-1.256 2.827-2.191 3.45-.479.319-.951.557-1.309.718v1.081c0 .548-.444.992-.991.992-.548 0-.992-.444-.992-.992v-1.75c0-.426.272-.804.676-.94h.003l.02-.008c.019-.006.05-.017.09-.033.081-.03.201-.079.347-.143.294-.131.678-.324 1.056-.576.815-.543 1.308-1.16 1.308-1.8 0-.593-.208-1.167-.59-1.62-.38-.453-.91-.757-1.494-.857zm4.067 2.478h-.991l.991.001zm-4.398 8.341c-.548 0-.992.444-.992.992 0 .547.444.991.992.991h.012c.547 0 .991-.444.991-.991 0-.548-.444-.992-.991-.992h-.012z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsAccountHelp);
export default __webpack_public_path__ + "static/media/icons_account_help.d6d9bfe7634f484d6cdc390a91344004.svg";
export { ForwardRef as ReactComponent };